import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  'https://bopvbykhekvrayihgfqm.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJvcHZieWtoZWt2cmF5aWhnZnFtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ1ODcyOTgsImV4cCI6MjA2MDE2MzI5OH0.PaJUSFBblBC7b74NrvDMNMZNMiLczHItdfJbMWCe5Lw'
);